import { useForm, useWatch } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
// import useFormPersist from 'react-hook-form-persist'
import { schemaUtils } from "../../../../../utils";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";
import StepFive from "./StepFive";
import StepSix from "./StepSix";
import StepSeven from "./StepSeven";
import StepEight from "./StepEight";
import StepNine from "./StepNine";
import StepTen from "./StepTen";
import StepEleven from "./StepEleven";
import StepTwelve from "./StepTwelve";
import StepThirteen from "./StepThirteen";
import StepFourteen from "./StepFourteen";
import StepFifteen from "./StepFifteen";
import StepSixteen from "./StepSixteen";
import StepSevenTeen from "./StepSevenTeen";
import StepEighteen from "./StepEighteen";
import StepNineteen from "./StepNineteen";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { MdDragIndicator } from "react-icons/md";
import BenefitPlanPayload from "./BenefitPlanPayload";
import { useNavigate, useParams, useSearchParams } from "react-router";

import { useMultiStepFormStore } from "../../../store/multiStepFormStore";
import useFormZustandPersist from "../../../hooks/useFormZustandPersist";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/authStore";
import { ALL_INSTRUCTIONS } from "../../../utils/constants";
import { findMatchingAccumulators } from "../../../utils/planUtils";
import AccumMappingRider from "./AccumMappingRider";
import { getPayloadFromFormData } from "../../../utils/benefitPlanUtils";
import Stepper from "../../shared/Stepper";
import ReactJson from "react-json-view";

const BenefitPlanMultiStepForm = () => {
    const [payload, setPayload] = useState({});
    const [instructions, setInstructions] = useState()

    const navigate = useNavigate();
    const { draftId: encodedDraftId } = useParams();
    const draftId = decodeURIComponent(encodedDraftId)
    const [searchParams, setSearchParams] = useSearchParams();
    //const draftId = searchParams.get("draftId"); // || crypto.randomUUID();

    const { isAuthenticated, email } = useAuthStore()
    const { updatedAt, drafts, getDraftByDraftId, addDraft, upsertDraft, removeDraftByDraftId } = useMultiStepFormStore();

    const activeDraft = drafts.find((d) => d.draftId === draftId); // getDraftByDraftId(draftId) //
    const activeStep = activeDraft?.activeStep; //activeDraftIdActiveStep; // || 1;

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isValid },
        control,
        trigger,
        setValue,
        getValues
    } = useForm({
        resolver: zodResolver(activeDraft?.action === 'Create' ? schemaUtils.benefitPlanMultiStepFormCreate : schemaUtils.benefitPlanMultiStepFormUpdate),
        mode: 'all',
        defaultValues: activeDraft || { draftId },
        resetOptions: {
            keepDefaultValues: true,
        },
    });

    useFormZustandPersist(draftId, {
        control,
        setValue,
        reset,
    });

    const action = useWatch({ control, name: 'action' });
    const originalValueList = useWatch({ control, name: 'originalValueList' });

    // onSelectedHandler for steps 7->10
    const updateAccumulatorFromMapping = (_event) => {
        const accum = getValues('accumulator')
        const validAccums = findMatchingAccumulators(accum)

        // TODO: we could reset the checkboxes if None is selected here
        setValue('accumulatorNotFound', false)

        if (validAccums.length == 1) {
            setValue('accumulatorFromMapping', {
                value: validAccums[0],
                label: validAccums[0].rider
            })
        } else {
            setValue('accumulatorFromMapping', null)
        }
    }

    useEffect(() => {
        if (action === 'Create') {
            setInstructions(ALL_INSTRUCTIONS.slice(0, 2))
            setValue('asOfDate', new Date("1800-01-01"), {})
            setValue('dependentAgeOutPolicy', '26 EOM')
            setValue('planRenewalInteraval', 12)
        } else {
            if (originalValueList) {
                setInstructions(ALL_INSTRUCTIONS)
            } else {
                setInstructions(ALL_INSTRUCTIONS.slice(0, 3))
            }
        }
    }, [action, originalValueList])

    //update the payload as form changes
    useEffect(() => {
        const allFormValues = getValues()
        setPayload(getPayloadFromFormData({ allFormValues, email }));
    }, [updatedAt, action]);

    const onSubmit = () => { };

    const nextStepHandler = async (step) => {
        const currentStep = getValues('activeStep')
        let isValid = true

        const { validation } = instructions.find((i) => i.step === step + 1);
        if (validation?.length) await trigger(validation);
        if (currentStep >= 7 && currentStep <= 10) {
            const accum = getValues('accumulator')
            const validAccums = findMatchingAccumulators(accum)
            if (validAccums.length == 0) {
                isValid = false
                setValue('accumulatorNotFound', true)
            } else {
                setValue('accumulatorNotFound', false)
            }
        }

        if (isValid) {
            setValue("activeStep", step + 1);
            upsertDraft({ activeStep: activeStep + 1, draftId });
        }
    };

    return (
        <div className="container " style={{ position: "relative" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <p className="title">{draftId}</p>
                </div>

                {activeDraft && <div>
                    <p
                        className="danger"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            removeDraftByDraftId(draftId);
                            navigate(`/config/plan-builder`);
                        }}
                    >
                        Delete Draft
                    </p>
                </div>}
            </div>

            <div className="steps-wrapper" style={{ padding: '1rem 0rem' }}>
                <Stepper
                    steps={instructions?.map(ins => ({ label: ins.instructions }))}
                    activeStep={activeStep}
                    onClickHandler={nextStepHandler}
                />
            </div>

            <br />
            <PanelGroup
                autoSaveId="review"
                direction="horizontal"
                style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "1rem", flex: 1, height: "100%", overflowY: "scroll" }}
            >
                <Panel
                    defaultSize={60}
                    style={{
                        height: "100%", width: "100%", display: "flex", alignItems: "start", justifyContent: "space-between", flexDirection: "column", gap: ".4rem",
                    }}
                >
                    <form
                        className="form scrollable-form"
                        onSubmit={handleSubmit(onSubmit)}
                        style={{
                            overflowY: "scroll",
                            scrollbarWidth: '1rem',
                            padding: "1rem",
                            // flex: 1,
                            flexGrow: 1,
                            width: "100%",
                            height: "100%",
                            position: "relative",
                        }}
                    >
                        {/* shared between 7 8 9 10 */}
                        <AccumMappingRider activeStep={activeStep} getValues={getValues} setValue={setValue} control={control} errors={errors} />
                        {getValues('accumulatorNotFound') && activeStep >= 7 && activeStep <= 10 &&
                            <div style={{ backgroundColor: 'red', color: 'white' }}>
                                <p>Accumulator Not Found</p>
                            </div>
                        }
                        <StepOne activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepTwo activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepThree activeStep={activeStep} control={control} errors={errors} getValues={getValues} />
                        <StepFour activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepFive activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepSix activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepSeven activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} updateAccumulatorFromMapping={updateAccumulatorFromMapping} />
                        <StepEight activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} updateAccumulatorFromMapping={updateAccumulatorFromMapping} />
                        <StepNine activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} updateAccumulatorFromMapping={updateAccumulatorFromMapping} />
                        <StepTen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} updateAccumulatorFromMapping={updateAccumulatorFromMapping} />
                        <StepEleven activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepTwelve activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepThirteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepFourteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepFifteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepSixteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepSevenTeen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                        <StepEighteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} payload={payload} />
                        <StepNineteen activeStep={activeStep} control={control} errors={errors} register={register} setValue={setValue} getValues={getValues} />
                    </form>
                </Panel>

                <PanelResizeHandle className="resize-handle" style={{ height: "100%" }}>
                    <div style={{ justifyContent: "center", display: "flex", alignItems: "center", height: "100%" }}>
                        {/* sadfsfasd */}
                        <MdDragIndicator size={"1.2rem"} />
                    </div>
                </PanelResizeHandle>

                <Panel defaultSize={40} style={{ height: "100%", overflow: "scroll" }}>
                    {/* <ReactJson
                        src={getValues()}
                        name={false}
                        collapsed={1}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        groupArraysAfterLength={false}
                        sortKeys={true}
                    /> */}
                    <BenefitPlanPayload control={control} getValues={getValues} payload={payload} errors={errors} isValid={isValid} trigger={trigger} />
                </Panel>
            </PanelGroup>
        </div>
    );
};

export default BenefitPlanMultiStepForm;
